export default __webpack_public_path__ + "static/media/Islanders.f34186ae.png";